import { render } from "./FooterContacts.vue?vue&type=template&id=9bf64870&scoped=true"
import script from "./FooterContacts.vue?vue&type=script&lang=js"
export * from "./FooterContacts.vue?vue&type=script&lang=js"

import "./FooterContacts.vue?vue&type=style&index=0&id=9bf64870&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bf64870"]])

export default __exports__